import React from 'react';

export function AttentionRow({
  title,
  reason,
  status,
  action,
}: {
  title: string;
  reason: React.ReactNode;
  status?: React.ReactNode;
  action: React.ReactElement;
}) {
  return (
    <div className="grid min-w-0 grid-cols-1 items-start gap-3 border-b border-border py-3 sm:grid-cols-[minmax(20ch,1fr)_auto_auto]">
      <div className="min-w-0">
        <p className="font-body text-body font-semibold text-text-heading">{title}</p>
        <div className="text-body text-text-muted">{reason}</div>
      </div>
      <div>{status}</div>
      <div className="[&_button]:min-h-11 [&_a]:min-h-11 sm:[&_button]:min-h-8 sm:[&_a]:min-h-8">
        {action}
      </div>
    </div>
  );
}
